<template lang="pug">
.container-restricao.row
    .col-8
        small Foram detectadas sobreposições com as seguintes terras indígenas:

        .list-group
            a.list-group-item.list-group-item-action.flex-cloumn.align-items-start.header-table
                .row.text-left
                    label.col-3 Código

                    label.col-8 Nome

            a.list-group-item.list-group-item-action.flex-cloumn.align-items-start.body-table(
                v-for='(restricao, index) in terrasIndigenas.restricoes'
            )
                .row.text-left
                    .col-3
                        span {{ restricao.properties.codigo_ti }}

                    .col-8
                        span {{ restricao.properties.nome }}

    .col-4(v-if='geometriaAreaMonitorada')
        mapa(
            v-if='layersMaps',
            :mapLayersConfigs='layersMaps',
            :mapConfig='mapConfig',
            :locked='true',
            :height='"180px"',
            :idMapa='"mapaRestricaoTerrasIndigenas"'
        )
</template>

<script>
import Mapa from '../../../components/MapaLeaflet';

import LayerStyle from '../../../utils/layerStyles';

export default {
    name: 'TerrasIndigenas',

    components: {
        Mapa
    },

    data() {
        return {
            layersMaps: null,
            mapConfig: {
                controls: {
                    fullscreen: true
                }
            }
        };
    },
    props: {
        terrasIndigenas: {
            type: Object,
            required: true
        },

        geometriaAreaMonitorada: {
            type: Object,
            require: false
        }
    },

    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.geometriaAreaMonitorada
            };

            this.layersMaps.push(layerAreaMonitorada);

            this.terrasIndigenas.restricoes.forEach(feature => {
                let layerRestricao = {
                    style: LayerStyle.RESTRICAO(),
                    geoJson: feature.geometry,
                    name: 'Terras indígenas',
                    tooltip: feature.properties.nome
                };

                this.layersMaps.push(layerRestricao);
            });
        }
    },
    mounted() {
        this.configureLayersMapa();
    }
};
</script>
